// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__20g3c","errors":"Errors_errors__TPf9Z"};